import React from 'react'
import hoc from '@hoc'
import PropTypes from 'prop-types'
import * as utils from '@utils'
import { API, DATE } from '@const'
import { Button, Select, MenuItem, FormControl, InputLabel, TextField, Grid } from '@material-ui/core'
import { Search } from '@material-ui/icons'
import Table from '@tables/table'
import AddPlatformRecommendDialog from '@dialogs/add-platform-recommend-dialog'
import EditPlatformRecommendDialog from '@dialogs/edit-platform-recommend-dialog'
import EditGameRecommendDialog from '@dialogs/edit-game-recommend-dialog'
import 'antd/dist/antd.css'
import { PfSubPfSelect } from '@select'
import ConfirmMsgDialog from '@msg/confirm-msg-dialog'
import { store } from '@redux/store'
import { Edit, Delete } from '@material-ui/icons'
import { SingleConfirmMsgDialog } from '@msg'
const COMPONENT_GROUP = 'popular_game_recommend_page'

class PopularGameRecommendPage extends React.Component {
    constructor(props) {
        super(props)
        this.t = (key) => {
            return utils.t(key, 'PopularGameRecommendPage')
        }
    }

    state = {
        openRoute: 'popular-game-recommend-page',
        rankInfo: [],
        updated_at: '',
        all_game_pf_id: '',
        platform_game_pf_id: 'all',
        platform_game_pfSubPfId: 'all',
        subPfSortList: [],
        searchStatus: 'active',
        searchName: '',
        paltformGameSearchMode: 'customizedNameSearch',
        searchList: ['customizedNameSearch', 'platformSearch', 'statusSearch'],
        platformGameData: [],
    }

    allGameColumns = [
        {
            field: 'serialNumber',
            render: (rowData) => {
                return this.getRankName(rowData.data, 0, 'rank')
            },
        },
        {
            field: 'gameName',
            render: (rowData) => {
                return this.getRankName(rowData.data, 0, 'name')
            },
        },
        {
            field: 'serialNumber',
            render: (rowData) => {
                return this.getRankName(rowData.data, 1, 'rank')
            },
        },
        {
            field: 'gameName',
            render: (rowData) => {
                return this.getRankName(rowData.data, 1, 'name')
            },
        },
        {
            field: 'serialNumber',
            render: (rowData) => {
                return this.getRankName(rowData.data, 2, 'rank')
            },
        },
        {
            field: 'gameName',
            render: (rowData) => {
                return this.getRankName(rowData.data, 2, 'name')
            },
        },
    ]

    platformColumns = [
        {
            field: 'serialNumber',
            render: (rowData) => {
                return <div>{rowData.id}</div>
            },
        },
        {
            field: 'customizedName',
            render: (rowData) => {
                return <div>{rowData.name}</div>
            },
        },
        {
            field: 'currency',
            render: (rowData) => {
                return <div>{utils.getPfCurrency(rowData.pf_id)}</div>
            },
        },
        {
            field: 'pfSubPfList',
            render: (rowData) => {
                return (
                    <div>
                        <Button
                            color="primary"
                            variant="contained"
                            className={this.props.classes.button}
                            onClick={() => {
                                this.singleConfirmDialog.OpenDialog({
                                    type: this.t('pfSubPfList'),
                                    msg: rowData['pf_sub_pf_list'].map((pfSubPfID) => utils.GeneratePfSubPfName(pfSubPfID)).join('\n'),
                                })
                            }}>
                            {this.t('view')}
                        </Button>
                    </div>
                )
            },
            cellStyle: {
                width: '90px',
            },
        },
        {
            field: 'isActive',
            render: (rowData) => {
                const statusData = { 
                    1: this.t('active'), 
                    2: this.t('close'), 
                    3: utils.t('noParticipate', 'AddPlatformRecommendDialog')
                }
                return <div> {statusData[rowData.status]} </div>
            },
            cellStyle: {
                width: '100px',
            },
        },
    ]

    actions = []

    getRankName(rowData, columnIndex, key) {
        const rank = rowData?.[columnIndex]?.[key]
        const name = store.getState().dataService.gameList.find((gameListitem) => gameListitem.game_code === rowData?.[columnIndex]?.[key])?.name_chs
        return <div>{key === 'name' ? name : rank}</div>
    }

    checkPermissions() {
        if (utils.checkValid(COMPONENT_GROUP + '.edit')) {
            this.platformColumns.push({
                field: '',
                render: (rowData) => {
                    return (
                        <div
                            onClick={() => {
                                this.editPlatformRecommendDialog.OpenDialog({
                                    title: this.t('edit'),
                                    rowData,
                                    openRoute: this.state.openRoute,
                                })
                            }}
                            className={this.props.classes.actionBtn}>
                            <Edit color="primary" />
                            {this.t('edit')}
                        </div>
                    )
                },
                cellStyle: {
                    width: '100px',
                },
            })
        }
        if (utils.checkValid(COMPONENT_GROUP + '.delete')) {
            this.platformColumns.push({
                field: '',
                render: (rowData) => {
                    return (
                        <div
                            onClick={() => {
                                this.deletePlatFormGameData(rowData.id)
                            }}
                            className={this.props.classes.actionBtn}>
                            <Delete color="primary" />
                            {this.t('delete')}
                        </div>
                    )
                },
                cellStyle: {
                    width: '100px',
                },
            })
        }
        if (utils.checkValid(COMPONENT_GROUP + '.add')) {
            this.actions.push({
                icon: 'add',
                text: 'add',
                isFreeAction: true,
                onClick: () => {
                    this.addPlatformRecommendDialog.OpenDialog({
                        title: this.t('add'),
                        rankInfo: this.state.rankInfo,
                        pf_id:
                            this.platformGamePfSubPfSelect.state.pfId === 'all'
                                ? this.platformGamePfSubPfSelect.state.pfList[0]
                                : this.platformGamePfSubPfSelect.state.pfId,
                        openRoute: this.state.openRoute,
                    })
                },
            })
        }
    }

    componentDidMount() {
        this.setState(
            {
                all_game_pf_id: utils.getEnablePlatform()[0],
            },
            () => {
                this.queryAllGameData()
                this.queryPlatformGameData()
                this.checkPermissions()
            }
        )
    }

    queryAllGameData() {
        this.allGameTable.SetLoading(true)
        utils.apiRequest(
            'get',
            API.RECOMMENDATIONS_TOP,
            {
                pf_id: this.state.all_game_pf_id,
            },
            (data) => {
                const { ranks, updated_at } = data
                const total = ranks.length //總筆數
                const rowCount = 3 // table 列筆數
                const colCount = 4 // table 行筆數
                const groupCount = rowCount * colCount // format 頁幾筆
                const pageCount = Math.floor(total / groupCount) + (total % groupCount ? 1 : 0) //總頁數
                const rankSortData = [] //給table的資料
                for (let page = 0; page < pageCount; page++) {
                    for (let n = 0; n < colCount; n++) {
                        const data = []
                        for (let t = 0; t < rowCount; t++) {
                            const value = n + colCount * t + page * groupCount + 1
                            if (value > total) break
                            data.push(value)
                        }
                        if (data.length > 0) rankSortData.push(data)
                    }
                }

                const formatRankInfo = rankSortData.reduce((value, item, index) => {
                    value[index] = {
                        data: [],
                    }
                    item.forEach((dataItem) => {
                        const filterData = ranks.find((ranksItem) => ranksItem.rank === dataItem)
                        if (filterData) {
                            const { rank, game_code: name } = filterData
                            value[index].data.push({ rank, name })
                        }
                    })
                    return value
                }, [])
                this.allGameTable.SetData(formatRankInfo)
                this.setState({ rankInfo: data.ranks, updated_at })
            },
            (_err) => {
                this.allGameTable.SetData([])
            },
            true
        )
    }

    queryPlatformGameData() {
        this.platformGameTable.SetLoading(true)
        const apiParams = {}
        
        if (this.state.platform_game_pf_id !== 'all') {
            apiParams.pf_id = this.state.platform_game_pf_id
        } else {
            apiParams.is_all = true
        }

        utils.apiRequest(
            'get',
            API.PLATFORM_RECOMMENDATIONS_TOP,
            apiParams,
            (data) => {
                this.setState({ platformGameData: data.data }, () => {
                    this.platformGameTable.SetData(this.state.platformGameData)
                    this.searchQuery()
                })
            },
            (_err) => {
                this.platformGameTable.SetData([])
            },
            true
        )
    }

    deletePlatFormGameData(id) {
        this.confirmDialog.OpenDialog({
            type: 'warn',
            msg: `${this.t('confirmDeleteMsg')}`,
            confirm: () => {
                utils.apiRequest(
                    'delete',
                    `${API.PLATFORM_RECOMMENDATIONS_TOP}/${id}`,
                    {},
                    (_data) => {
                        this.queryPlatformGameData()
                        this.confirmDialog.closeDialog()
                    },
                    (_err) => {
                        this.platformGameTable.SetData([])
                    },
                    true
                )
            },
        })
    }

    searchQuery() {
        switch (this.state.paltformGameSearchMode) {
            case 'customizedNameSearch':
                this.platformGameTable.SetData(this.state.platformGameData.filter((item) => item.name.includes(this.state.searchName)))
                break
            case 'platformSearch':
                this.platformGameTable.SetData(
                    this.state.platform_game_pfSubPfId === 'all'
                        ? this.state.platformGameData
                        : this.state.platformGameData.filter((item) => item.pf_sub_pf_list.includes(this.state.platform_game_pfSubPfId))
                )
                break
            case 'statusSearch':
                this.platformGameTable.SetData(
                    this.state.platformGameData.filter((item) => item.status === (this.state.searchStatus === 'active' ? 1 : 2))
                )
                break
            default:
                this.platformGameTable.SetData(this.state.platformGameData)
                break
        }
    }

    render() {
        const isCustomizedNameSearch = this.state.paltformGameSearchMode === 'customizedNameSearch'
        const isPlatformSearch = this.state.paltformGameSearchMode === 'platformSearch'
        const isStatusSearch = this.state.paltformGameSearchMode === 'statusSearch'
        return (
            <Grid container spacing={2}>
                <Grid item className={this.props.classes.alignCenter}>
                    <PfSubPfSelect
                        onRef={(ref) => (this.allGamePfSubPfSelect = ref)}
                        options={{
                            pfChangeCallback: () => {
                                this.setState(
                                    {
                                        all_game_pf_id: this.allGamePfSubPfSelect.state.pfId,
                                    },
                                    () => {
                                        this.queryAllGameData()
                                    }
                                )
                            },
                            hideAutocomplete: true,
                            hideAllPlatform: true,
                        }}
                    />
                </Grid>
                {utils.checkValid(COMPONENT_GROUP + '.edit') && (
                    <Grid item className={this.props.classes.alignCenter}>
                        <Button
                            variant="contained"
                            color="primary"
                            onClick={() => {
                                this.editGameRecommendDialog.OpenDialog({
                                    title: this.t('edit') + utils.t('rank', 'EventDialog'),
                                    rankInfo: this.state.rankInfo,
                                    pf_id: this.state.all_game_pf_id,
                                    openRoute: this.state.openRoute,
                                })
                            }}>
                            <Search className={this.props.classes.rightIcon} />
                            {this.t('edit') + utils.t('rank', 'EventDialog')}
                        </Button>
                    </Grid>
                )}
                <Grid item className={this.props.classes.alignCenter}>
                    <span className={this.props.classes.infoContent}>
                        <div></div>
                        {utils.t('rank', 'EventDialog') + utils.t('updatedAt', 'EventPrizeDetailRedPacketDialog')} :{' '}
                        {' ' + utils.unixToDateTime(this.state.updated_at)}
                        {' ( GMT' + DATE.CLIENT_UTC_OFFSET + ' )'}
                    </span>
                </Grid>
                <Grid item xs={12}>
                    <Table
                        ownerName="PopularGameRecommendPage"
                        columns={this.allGameColumns}
                        options={{
                            tableLayout: 'fixed',
                            pageSize: 4,
                            pageSizeOptions: [],
                            search: false,
                            sorting: false,
                        }}
                        onRef={(ref) => (this.allGameTable = ref)}
                    />
                </Grid>
                <Grid item xs={12}>
                    <Grid item className={this.props.classes.alignCenter}>
                        <PfSubPfSelect
                            onRef={(ref) => (this.platformGamePfSubPfSelect = ref)}
                            options={{
                                pfChangeCallback: () => {
                                    this.pfSubPfRef = React.createRef()
                                    this.setState(
                                        {
                                            platform_game_pf_id: this.platformGamePfSubPfSelect.state.pfId,
                                            platform_game_pfSubPfId: 'all',
                                        },
                                        () => {
                                            console.log(this.state, 'this.state')
                                            this.forceUpdate()
                                            this.queryPlatformGameData()
                                        }
                                    )
                                },
                                hideAutocomplete: true,
                                hideAllPlatform: false,
                            }}
                        />
                    </Grid>
                    <Grid item className={this.props.classes.alignCenter}>
                        <FormControl className={this.props.classes.formControl}>
                            <InputLabel>{this.t('searchMethod')}</InputLabel>
                            <Select
                                value={this.state.paltformGameSearchMode}
                                onChange={(event) => {
                                    const value = event.target.value
                                    this.setState({
                                        paltformGameSearchMode: value,
                                    })
                                }}>
                                {this.state.searchList.map((item) => (
                                    <MenuItem value={item} key={item}>
                                        {this.t(item)}
                                    </MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                    </Grid>
                    {isCustomizedNameSearch && (
                        <Grid item className={this.props.classes.alignCenter}>
                            <TextField
                                value={this.state.searchName}
                                onChange={(event) => {
                                    this.setState({
                                        searchName: event.target.value,
                                    })
                                }}
                                variant="standard"
                                placeholder={this.t('enterSearchKeywords')}
                                type="text"
                            />
                            <div onClick={() => this.setState({ searchName: '' })} className={this.props.classes.clearSearch}>
                                X
                            </div>
                        </Grid>
                    )}
                    {isPlatformSearch &&
                        (() => {
                            const subPfSortList = this.platformGamePfSubPfSelect.state.subPfSortList.reduce((value, item) => {
                                value[item.pf_sub_pf_id] = item.name
                                return value
                            }, {})
                            return (
                                <Grid ref={this.pfSubPfRef} item className={this.props.classes.alignCenter}>
                                    <FormControl className={this.props.classes.formControl}>
                                        <InputLabel>{this.t('pfSubPf')}</InputLabel>
                                        <Select
                                            value={this.state.platform_game_pfSubPfId}
                                            onChange={(event) => {
                                                this.setState({
                                                    platform_game_pfSubPfId: event.target.value,
                                                })
                                            }}>
                                            {
                                                <MenuItem value={'all'} key={'all'}>
                                                    {utils.t('allSubPlatform', 'PfSubPfSelect')}
                                                </MenuItem>
                                            }
                                            {Object.keys(subPfSortList).map((item) => (
                                                <MenuItem value={item} key={item}>
                                                    {subPfSortList[item]}
                                                </MenuItem>
                                            ))}
                                        </Select>
                                    </FormControl>
                                </Grid>
                            )
                        })()}
                    {isStatusSearch && (
                        <Grid item className={this.props.classes.alignCenter}>
                            <FormControl className={this.props.classes.formControl}>
                                <InputLabel>{this.t('isActive')}</InputLabel>
                                <Select
                                    value={this.state.searchStatus}
                                    onChange={(event) => {
                                        this.setState({
                                            searchStatus: event.target.value,
                                        })
                                    }}>
                                    {['active', 'close'].map((item) => (
                                        <MenuItem value={item} key={item}>
                                            {this.t(item)}
                                        </MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                        </Grid>
                    )}
                    <Grid item className={this.props.classes.alignCenter}>
                        <Button
                            className={this.props.classes.searchBtn}
                            variant="contained"
                            color="primary"
                            onClick={() => {
                                this.searchQuery()
                            }}>
                            <Search className={this.props.classes.rightIcon} />
                            {this.t('search', {})}
                        </Button>
                    </Grid>
                    <Table
                        ownerName="PopularGameRecommendPage"
                        columns={this.platformColumns}
                        options={{
                            tableLayout: 'fixed',
                            pageSize: 10,
                            search: false,
                            sorting: false,
                        }}
                        actions={this.actions}
                        onRef={(ref) => (this.platformGameTable = ref)}
                    />
                </Grid>
                <ConfirmMsgDialog onRef={(ref) => (this.confirmDialog = ref)} />
                <EditGameRecommendDialog
                    onRef={(ref) => {
                        this.editGameRecommendDialog = ref
                    }}
                    confirmCallback={() => {
                        this.queryAllGameData()
                    }}
                />
                <AddPlatformRecommendDialog
                    onRef={(ref) => {
                        this.addPlatformRecommendDialog = ref
                    }}
                    confirmCallback={(params) => {
                        this.platformGamePfSubPfSelect.setState(
                            {
                                pfId: params?.pf_id,
                            },
                            () => {
                                this.setState({
                                    platform_game_pf_id: this.platformGamePfSubPfSelect.state.pfId,
                                })
                            }
                        )
                        this.queryPlatformGameData()
                    }}
                />
                <EditPlatformRecommendDialog
                    onRef={(ref) => {
                        this.editPlatformRecommendDialog = ref
                    }}
                    confirmCallback={() => {
                        this.queryPlatformGameData()
                    }}
                />
                <SingleConfirmMsgDialog onRef={(ref) => (this.singleConfirmDialog = ref)} />
            </Grid>
        )
    }
}

const styles = (theme) => {
    return {
        alignCenter: {
            display: 'inline-flex',
            alignItems: 'center',
            position: 'relative',
        },
        clearSearch: {
            color: '#BFBFBF',
            cursor: 'pointer',
            position: 'absolute',
            right: '0',
        },
        searchBtn: {
            marginLeft: '20px',
        },
        rightIcon: {
            marginRight: theme.spacing(1),
        },
        infoContent: {
            fontWeight: 'bold',
            fontSize: '16px',
        },
        actionBtn: {
            cursor: 'pointer',
        },
        formControl: {
            margin: theme.spacing(1),
            width: '150px',
        },
    }
}

PopularGameRecommendPage.propTypes = {
    classes: PropTypes.object.isRequired,
    auth: PropTypes.object,
}

export default hoc(styles)(PopularGameRecommendPage)
